const REFERRAL_ID_PARAM_KEY = 'utm_campaign';
const REFERRAL_SOURCE_PARAM_KEY = 'utm_source';
const REFERRAL_SOURCE_VALUE = 'friends';

export class ReferralService {
  private static getReferrerIdFromSearchParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const spReferrerId = urlParams.get(REFERRAL_ID_PARAM_KEY);
    const spReferralSource = urlParams.get(REFERRAL_SOURCE_PARAM_KEY);

    if (spReferralSource !== REFERRAL_SOURCE_VALUE || !spReferrerId) {
      return;
    }

    return spReferrerId;
  }

  private static getReferrerIdFromLocalStorage() {
    const lsReferrerId = localStorage.getItem(REFERRAL_ID_PARAM_KEY);
    const lsReferralSource = localStorage.getItem(REFERRAL_SOURCE_PARAM_KEY);

    if (lsReferralSource !== REFERRAL_SOURCE_VALUE || !lsReferrerId) {
      return;
    }

    return lsReferrerId;
  }

  static getReferrerUniqueId() {
    const referrerUniqueId = this.getReferrerIdFromSearchParams() || this.getReferrerIdFromLocalStorage();

    return referrerUniqueId;
  }

  static updateReferralData() {
    const spReferrerId = this.getReferrerIdFromSearchParams();

    if (spReferrerId) {
      localStorage.setItem(REFERRAL_ID_PARAM_KEY, spReferrerId);
      localStorage.setItem(REFERRAL_SOURCE_PARAM_KEY, REFERRAL_SOURCE_VALUE);
    }
  }
}
